<template>
    <div class="u-full-width">
        <p>Verteilung nach Jahr</p>
        <CanvasJSChart :options="options" :styles="styleOptions"/>
    </div>
</template>

<script>
import CanvasJSChart from './CanvasJSVueComponent.vue'

export default {
    components: {
        CanvasJSChart,
    },

    props: {
        /**
         * { label: '2023', y: 15 }
         */
        dataPoints: { type: Array, required: true },
    },

    data: () => ({
        styleOptions: {
            width: '100%',
            height: '360px',
        },
    }),

    computed: {
        options () {
            return {
                theme: 'light',
                animationEnabled: true,
                data: [{
                    type: 'pie',
                    indexLabel: '{label} (#percent%)',
                    yValueFormatString: '#,##0',
                    toolTipContent: '<span style=\'"\'color: {color};\'"\'>{label}</span> {y}(#percent%)',
                    dataPoints: this.dataPoints,
                }],
            }
        },
    },
}
</script>
